import React from "react";
import { Box } from "@mui/material";
import CodeIcon from "@mui/icons-material/Code";
import IndexCardSkillBadge from "./IndexCardSkillBadge";
import { getTypeColor } from "../../../../constants/colors";

/**
 * スキル一覧をバッジとして横並び表示する行コンポーネント
 */

const IndexCardSkillRow = ({ type, skills, isNew }) => {
  if (!skills || skills.length === 0) return null;

  const shouldAlignTop = skills.length > 1; // 2つ以上なら折り返しの可能性あり

  // job → 青, project → 紫
  const colors = getTypeColor(type);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: shouldAlignTop ? "flex-start" : "center",
        gap: 0.6,
      }}
    >
      <CodeIcon
        sx={{
          color: colors,
          fontSize: { xs: 14, sm: 18 },
          mt: shouldAlignTop ? "2px" : "0px",
        }}
      />

      <Box sx={{ display: "flex", gap: 0.6, flexWrap: "wrap" }}>
        {skills.map((s) => (
          <IndexCardSkillBadge
            key={s.skill_name}
            type={type}
            label={s.skill_name}
            isNew={isNew}
          />
        ))}
      </Box>
    </Box>
  );
};

export default IndexCardSkillRow;
